module.exports = __webpack_public_path__ + "static/media/sierra.999d61ab.webp";